import React, { useEffect, useState, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useSelector, useDispatch } from 'react-redux';
import { setOpenAnalytics } from '../store/reducers/analyticsSlice';
import { globalConfig } from '../configuration/config';

const Analytics = () => {
  const dispatch = useDispatch();
  const open = useSelector((state) => state.analytics?.open);
  const currentLink = useSelector((state) => state.publicLink?.defaultValues?.publicLinkUrl);
  const [insights, setInsights] = useState(null);
  const [isB2B, setIsB2B] = useState(true);
  const [isB2C, setIsB2C] = useState(true);

  const block = useRef(null);

  const fetchAnalytics = async () => {
    if (!currentLink) return;

    try {
      const params = new URLSearchParams({
        publicLinkGuid: currentLink,
        isB2B: isB2B.toString(),
        isB2C: isB2C.toString(),
      });

      const response = await fetch(
        `${
          globalConfig.config.common.api
        }StructureUrls/GetPublicLinkAnalytics?${params.toString()}`,
        {
          method: 'GET',
          credentials: 'include',
        },
      );

      if (!response.ok) throw new Error('Ошибка при получении аналитики');

      const data = await response.json();
      setInsights(data);
    } catch (error) {
      console.error('[Analytics] Ошибка загрузки:', error);
    }
  };

  useEffect(() => {
    if (open && currentLink) {
      fetchAnalytics();
    }
  }, [open, isB2B, isB2C]);

  if (block.current) {
    block.current.parentNode.classList.add('analytics-wrapper');
  }

  const handleB2BChange = (e) => {
    const checked = e.target.checked;
    if (!checked && !isB2C) {
      setIsB2C(true);
    }
    setIsB2B(checked);
  };

  const handleB2CChange = (e) => {
    const checked = e.target.checked;
    if (!checked && !isB2B) {
      setIsB2B(true);
    }
    setIsB2C(checked);
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="lg"
      PaperProps={{
        style: {
          backgroundColor: '#fafafa',
          boxShadow: 'none',
        },
      }}
      onClose={() => dispatch(setOpenAnalytics(false))}>
      <DialogContent className="analytics-wrap" ref={block} style={{ minHeight: '400px' }}>
        <div className="share">
          <div className="flex between" style={{ alignItems: 'center' }}>
            <span>Аналитика VarStudio</span>
            <div style={{ display: 'flex', gap: '16px' }}>
              <FormControlLabel
                control={<Checkbox checked={isB2B} onChange={handleB2BChange} />}
                label="Статистика сотрудника B2B"
              />
              <FormControlLabel
                control={<Checkbox checked={isB2C} onChange={handleB2CChange} />}
                label="Статистика клиента B2C"
              />
            </div>
          </div>
          <div className="analytics-info-title">{insights?.calculationName}</div>
          <div className="analytics-info">
            <div className="analytics-info-item">
              <div className="analytics-info-name">Просмотров товаров в 3D</div>
              <div className="analytics-info-value">{insights?.threeDCount}</div>
            </div>

            <div className="analytics-info-item">
              <div className="analytics-info-name">Суммарное время покупателей в 3D, мин.</div>
              <div className="analytics-info-value">{insights?.widgetUseTime}</div>
            </div>
            <div className="analytics-info-item">
              <div className="analytics-info-name">Просмотров товаров в AR</div>
              <div className="analytics-info-value">{insights?.arCount}</div>
            </div>
            <div className="analytics-info-item">
              <div className="analytics-info-name">Суммарное время покупателей в AR, мин.</div>
              <div className="analytics-info-value">0</div>
            </div>
            <div className="analytics-info-item">
              <div className="analytics-info-name">Просмотров товаров в VR</div>
              <div className="analytics-info-value">{insights?.vrCount}</div>
            </div>
            <div className="analytics-info-item">
              <div className="analytics-info-name">Суммарное время покупателей в VR, мин.</div>
              <div className="analytics-info-value">{insights?.widgetUseTime}</div>
            </div>
          </div>

          <div className="analytics-info-title">После просмотра товара в 3D и AR</div>
          <div className="analytics-info">
            <div className="analytics-info-item">
              <div className="analytics-info-name">Добавлено товаров в корзину, шт.</div>
              <div className="analytics-info-value">{insights?.variantsCount}</div>
            </div>
            <div className="analytics-info-item">
              <div className="analytics-info-name">Добавлено товаров в корзину, руб.</div>
              <div className="analytics-info-value">{insights?.ordersCount}</div>
            </div>
            <div className="analytics-info-item">
              <div className="analytics-info-name">Куплено товаров, шт.</div>
              <div className="analytics-info-value">0</div>
            </div>
            <div className="analytics-info-item">
              <div className="analytics-info-name">Куплено товаров на сумму, руб.</div>
              <div className="analytics-info-value">0</div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Analytics;
